import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

import environment from '@app/environments/environment';
import * as models from '@app/models/index';

@Injectable()
export class UserService {
	private baseUrl = environment.apiGateway.apiUrl;
	private userApiUrl = '';

	constructor() {
		this.userApiUrl = this.baseUrl + 'User/';
	}

	/**
	 *  Get all users
	 */
	public async getUsers(cancelToken?: CancelToken): Promise<models.IUser[]> {
		try {
			const res = await axios.get<models.IUser[]>(this.userApiUrl, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Add new user
	 */
	public async addUser(user: models.IAddUser, cancelToken?: CancelToken): Promise<models.IUser> {
		try {
			const res = await axios.post<models.IUser>(this.userApiUrl, user, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Update user
	 */
	public async updateUser(id: string, user: models.IAddUser, cancelToken?: CancelToken): Promise<models.IUser> {
		try {
			const url = this.userApiUrl + id;
			const res = await axios.put<models.IUser>(url, user, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Delete user
	 */
	public async deleteUser(id: string, cancelToken?: CancelToken): Promise<boolean> {
		try {
			const url = this.userApiUrl + id;
			const res = await axios.delete(url, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Resend invitation to the user
	 */
	public async resendUserInvitation(userId: string, cancelToken?: CancelToken): Promise<boolean> {
		try {
			const url = this.userApiUrl + `${userId}/resend-invite`;
			const res = await axios.post<boolean>(url, null, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts